import firebase from 'firebase'
import firebaseOptions from '../../Root/Providers/FirebaseProvider/firebaseOptions'
const fireBaseApp = firebase.initializeApp(firebaseOptions)
const auth = firebase.auth()
const db = fireBaseApp.firestore()

export {auth, db}
